export const CHAT_HTML_CONTENT_TYPE = 'text/html';
export const CHAT_HTML_CONTENT_TYPE_WITH_UTF8_CHARSET = `${CHAT_HTML_CONTENT_TYPE};charset=utf-8`;
export const DEFAULT_CHAT_HTML_FILE_NAME = 'attachment.html';
export const CHAT_HTML_RESIZE_MESSAGE_TYPE = 'randol-chat:resize';
